import { useState, useCallback, useRef, useEffect } from 'react';
import { getUserTotalAWard } from 'src/apis/article.api';

const useRankBadgeTooltip = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [totalAwardedPoints, setTotalAwardedPoints] = useState<any>({});
  const isFetching = useRef(false);
  const fetchedWriterId = useRef<string | null>(null);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  const fetchTotalAwardedPoints = useCallback(async (writerId) => {
    // Only fetch once per writerId per hook instance
    if (isFetching.current || fetchedWriterId.current === writerId) return;
    isFetching.current = true;
    try {
      const result = await getUserTotalAWard(writerId);
      setTotalAwardedPoints(result);
      fetchedWriterId.current = writerId;
    } catch (error) {
      console.error('Failed to fetch awarded points:', error);
    } finally {
      isFetching.current = false;
    }
  }, []);

  const handleMouseEnter = (writerId) => {
    if (!isTouchDevice) {
      setOpenPopup(true);
      fetchTotalAwardedPoints(writerId);
    }
  };

  const handleClick = (writerId) => {
    setOpenPopup((prev) => {
      if (!prev) {
        fetchTotalAwardedPoints(writerId);
      }
      return !prev;
    });
  };

  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setOpenPopup(false);
    }
  };

  return {
    openPopup,
    totalAwardedPoints,
    handleMouseEnter,
    handleClick,
    handleMouseLeave,
    isTouchDevice
  };
};

export default useRankBadgeTooltip;
